export const UPDATE_LOADING = 'UPDATE_LOADING'
export const UPDATE_LOADING_PREVIEW_ARTICLES = 'UPDATE_LOADING_PREVIEW_ARTICLES'
export const UPDATE_LOADING_DESCRIPTION = 'UPDATE_LOADING_DESCRIPTION'
export const UPDATE_ARTICLE_SUBMITTING = 'UPDATE_ARTICLE_SUBMITTING'
export const UPDATE_ATTACHMENT_SUBMITTING = 'UPDATE_ATTACHMENT_SUBMITTING'
export const UPDATE_LOADING_LATEST_ARTICLES = 'UPDATE_LOADING_LATEST_ARTICLES'
export const UPDATE_CATEGORY_SUBMITTING = 'UPDATE_CATEGORY_SUBMITTING'
export const UPDATE_DATASET_SUBMITTING = 'UPDATE_DATASET_SUBMITTING'
export const UPDATE_DISCOVERY_SUBMITTING = 'UPDATE_DISCOVERY_SUBMITTING'
export const UPDATE_WEBPAGE_SUBMITTING = 'UPDATE_WEBPAGE_SUBMITTING'
export const UPDATE_HELP_SUBMITTING = 'UPDATE_HELP_SUBMITTING'
export const UPDATE_INSIGHT_SUBMITTING = 'UPDATE_INSIGHT_SUBMITTING'
export const UPDATE_LOADING_SEARCH_RESULTS = 'UPDATE_LOADING_SEARCH_RESULTS'
export const UPDATE_USER_SUBMITTING = 'UPDATE_USER_SUBMITTING'
export const UPDATE_LOGIN_SUBMITTING = 'UPDATE_LOGIN_SUBMITTING'
export const UPDATE_SITE_SUBMITTING = 'UPDATE_SITE_SUBMITTING'
export const UPDATE_TAG_SUBMITTING = 'UPDATE_TAG_SUBMITTING'
